import * as _ from 'lodash'

import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
  WB_CustomerRow,
  WB_CannibalizationSetRow,
  WB_DomainItemRow,
  WB_ProductGroupRow,
  WB_CannibalizationSetCustomerRow,
  WB_CannibalizationSetProductGroupRow, WB_EventRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbCannibalizationSet} from "../PA.Core/PAdbSchemaRowsIF";



import {
  esWB_Cannibalization_Set,
  esWB_Cannibalization_Set_Customer, esWB_Cannibalization_Set_Product,
  esWB_Cannibalization_Set_Product_Group,
  esWB_Customer,
  esWB_Domain_Item,
  esWB_Product_Group
} from "../PA.Core/PAdbSchema";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {
  ICannibalizationSet,
  ICannibalizationSetChangedEvent,
  ICannibalizationSetProductGroup,
  ICannibalizationSetProductGroupAddOptions,
  ICannibalizationSetProductGroupChangedEvent
} from "../PA.Consumption.Core/PA.Consumption.IF";
import {BehaviorSubject} from "rxjs";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {PAusrContext} from "../PA.Core/PAusrContext";
import {CannibalizationDataUtils} from "../PA.Consumption.Core/CannibalizationDataUtils";
import {IHaveExecutionBounds} from "../PA.Core/PA.Core.IF.Aspects";
import {ManualExecutionBounds} from "../PA.Utils/ManualExecutionBounds";
import {CannibalizationGroupManualExecutionBoundsProductsProvider} from "../PA.Utils/ManualExecutionBoundsUtils";
import {
  ICannibalizationSetActualsCalculator,
  IHaveCannibalizationSetActualsCalculator
} from "../PA.Consumption.Services/PA.Consumption.Services.IF";
import {CannibalizationSetActualsCalculator} from "../PA.Consumption.Services/CannibalizationSetActualsCalculator";

export interface ICannibalizationSetLoadOptions {
  dbContext?: PAdbContext

  // Create New
  CannibalizationSetTypeId?: number
  CustomersIds?: number[]
  AffinitySetId?: number
  DateFrom?: Date
  DateThru?: Date
}

const CannibalizationSetLoadOptions_default: ICannibalizationSetLoadOptions = {}

export class CannibalizationSetBO
  implements
    IBusinessObject,
    ICannibalizationSet,
    ICannibalizationSetProductGroup,
    IHaveCannibalizationSetActualsCalculator
{

  //<editor-fold desc = "Properties and Constructor">

  Identity: IdentityProvider;

  CreateOptions: any;

  LoadOptions: any;
  _bIsLoaded: boolean;
  _OnLoadComplete: Promise<IBusinessObject>;
  LoadProgressProvider: IProgressProvider;

  ValidateOptions: any;
  _bIsValidated: boolean;
  ValidateMessageProvider: IMessageProvider;
  ValidateProgressProvider: IProgressProvider;

  SaveOptions: any;
  _bIsSaved: boolean;
  SaveProgressProvider: IProgressProvider;

  DeleteOptions: any;
  _bIsDeleted: boolean;
  DeleteMessageProvider: IMessageProvider;
  DeleteProgressProvider: IProgressProvider;

  dbContext: PAdbContext;
  drWB_CannibalizationSet: WB_CannibalizationSetRow;

  constructor(options?: any) {

    this.CreateOptions = options || {};

    if ('dbContext' in this.CreateOptions)
      this.dbContext = this.CreateOptions.dbContext;

    this.Identity = new IdentityProvider({id: 0, name: 'New Cannibalization Set'});

    this.LoadOptions = {};
    this._bIsLoaded = false;
    this._OnLoadComplete = undefined;
    this.LoadProgressProvider = new ProgressProvider('Loading', this);

    this.ValidateOptions = {};
    this._bIsValidated = false;
    this.ValidateMessageProvider = new MessageProvider();
    this.ValidateProgressProvider = new ProgressProvider("Validating", this);

    this.SaveOptions = {};
    this._bIsSaved = false;
    this.SaveProgressProvider = new ProgressProvider("Saving", this);

    this.DeleteOptions = {};
    this._bIsDeleted = false;
    this.DeleteMessageProvider = new MessageProvider();
    this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

    this.drWB_CannibalizationSet = undefined;

    this.ICannibalizationSet_init()
    this.ICannibalizationSetProductGroup_init()
    this.ICannibalizationSetContext_init()
    this.ICannibalizationSetActualsCalculator_init()

  }

  //</editor-fold>

  get WB_CannibalizationSet(): WB_CannibalizationSetRow {
    return this.drWB_CannibalizationSet;
  }


  //<editor-fold desc = "IBusinessObject operations">

  LoadNew(options?: ICannibalizationSetLoadOptions): Promise<IBusinessObject> {
    const self = this;
    this.LoadProgressProvider.start("Creating Cannibalization Set");
    let createOpts = _.defaultsDeep({}, self.CreateOptions, options)

    let internalOnComplete = new Promise<IBusinessObject>( (resolve, error) => {

      self.LoadOptions = options || {};
      if('dbContext' in self.LoadOptions)
        self.dbContext = self.LoadOptions.dbContext;
      else
        self.dbContext = new PAdbContext();

      if(self.dbContext == null) {
        var sError = "Unable to determine dbContext for new Cannibalization Set.";
        self.LoadProgressProvider.exception(sError);
        error(sError);
        return;
      }

      // Create record using dbContext
      self.dbContext.createRecordWithKey(esWB_Cannibalization_Set)
        .then((newCannibalizationSetRow: WB_CannibalizationSetRow) => {
          newCannibalizationSetRow.setDefaults()
          self.drWB_CannibalizationSet = newCannibalizationSetRow;
          self.dbContext.add(esWB_Cannibalization_Set, newCannibalizationSetRow)
          self.Identity.setAll(self.WB_CannibalizationSet.cif.WB_CANN_ID, self.WB_CannibalizationSet.cif.WB_CANN_ID, self.WB_CannibalizationSet.cif.CANN_NAME);
          self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
          self.Identity.listenToRecordUpdates(self.WB_CannibalizationSet, 'WB_CANN_ID', 'WB_CANN_ID', 'CANN_NAME')

          self.drWB_CannibalizationSet.cif.CANN_NAME = "New Cannibalization Set"
          self.drWB_CannibalizationSet.cif.CANNIB_TYPE_ID = createOpts.CannibalizationSetTypeId
          self.drWB_CannibalizationSet.EffectiveStartDt = createOpts.DateFrom
          self.drWB_CannibalizationSet.EffectiveEndDt = createOpts.DateThru
          self.drWB_CannibalizationSet.cif.WB_PRDGRP_ID_AFFSET = createOpts.AffinitySetId
          let usrContext: PAusrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
          if(!_.isEmpty(usrContext)){
            self.drWB_CannibalizationSet.WB_UserRow = usrContext.User
            self.drWB_CannibalizationSet.cif.WB_AUTHUSR_ID = usrContext.User.cif.WB_AUTHUSR_ID
          }

          return self.dbContext.findUsingCache(esWB_Domain_Item, [createOpts.CannibalizationSetTypeId])
        })
        .then((arrCannibalizationTypes: WB_DomainItemRow[]) => {
          if(!_.isEmpty(arrCannibalizationTypes)){
            self.drWB_CannibalizationSet.WB_CannibalizationTypeRow = arrCannibalizationTypes[0]
          }

          return self.dbContext.findUsingCache(esWB_Product_Group, [createOpts.AffinitySetId])
        })
        .then((arrProductGroups: WB_ProductGroupRow[]) => {
          if(!_.isEmpty(arrProductGroups)){
            self.drWB_CannibalizationSet.WB_AffinitySet_ProductGroupRow = arrProductGroups[0]
          }


          let addNewCusts = async function(){
            let idxCust: number = 0

            for(idxCust = 0; idxCust < createOpts.CustomersIds.length; idxCust++){
              // Add Customer
              await self.addCustomer(createOpts.CustomersIds[idxCust])
            }
            return
          }

          return addNewCusts()
        })
        .then((ignore:any) => {
          //

          // Wire up Change Events
          self.drWB_CannibalizationSet.setupOnChangeEvents([], self.ICannibalizationSet_onRecordChange.bind(self), self)
          _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (cspg) => {
            cspg.setupOnChangeEvents([],self.ICannibalizationSetProductGroup_onRecordChange.bind(self), self)
          })

          return self._AttributesOnLoadComplete()
        })
        .then((ignore:any) => {

          self.ICannibalizationSetActualsCalculator_onLoadComplete()

          self.LoadProgressProvider.finish();
          self._bIsLoaded = true;
          self._OnLoadComplete = null;
          resolve(self);

        })
        .catch((err) => {
          self.LoadProgressProvider.exception(err)
          error(err)
        })

    });

    self._OnLoadComplete = internalOnComplete

    return  new Promise<IBusinessObject>( (resolve, error) => {
      internalOnComplete
        .then((BO) => {
          return ASync.resolve()
        }).then((ignored) => {
        self._bIsLoaded = true;
        self._OnLoadComplete = undefined
        self.LoadProgressProvider.finish()
        resolve(self)
      }).catch((err) => {
        self._OnLoadComplete = undefined
        self.LoadProgressProvider.exception(err)
        error(err)
      })
    })
  }

  Load(anId: number | number, options?: object): Promise<IBusinessObject> {

    const self = this;

    let recordResolver: ESRecordResolver
    let recordResolverLoadPromise: Promise<void>

    self.LoadProgressProvider.start("Loading (" + anId + ")");

    self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

      if (self.bIsLoaded) {
        self.LoadProgressProvider.exception("Cannibalization Set already loaded.")
        resolve(self);
        return;
      }

      self.LoadOptions = options || {};
      _.defaults(self.LoadOptions, CannibalizationSetLoadOptions_default)


      if ('dbContext' in self.LoadOptions)
        self.dbContext = self.LoadOptions.dbContext;
      else if (_.isEmpty(self.dbContext)) {
        self.dbContext = new PAdbContext({});
      }

      if (_.isEmpty(self.dbContext)) {
        error("Unable to determine dbContext for Cannibalization Set.")
        return;
      }

      if('RecordResolver' in self.LoadOptions) {
        recordResolver = (<any> self.LoadOptions).RecordResolver
        recordResolverLoadPromise = ASync.resolve()
      } else {
        recordResolver = CannibalizationSetBO.createRecordResolver({dbContext: self.dbContext})
        recordResolverLoadPromise = CannibalizationSetBO.setupRecordResolver(recordResolver, [anId])
      }


      recordResolverLoadPromise
        .then(function () {
          let aCannibalizationSetRow: any = recordResolver.get(esWB_Cannibalization_Set, anId)

          if (_.isEmpty(aCannibalizationSetRow)) {
            error("Cannibalization Set not Found");
            return;
          }

          self.drWB_CannibalizationSet = aCannibalizationSetRow;
          self.Identity.setAll(self.WB_CannibalizationSet.cif.WB_CANN_ID, self.WB_CannibalizationSet.cif.WB_CANN_ID, self.WB_CannibalizationSet.cif.CANN_NAME);
          self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
          self.Identity.listenToRecordUpdates(self.WB_CannibalizationSet, 'WB_CANN_ID', 'WB_CANN_ID', 'CANN_NAME')


          // Wire up Change Events
          self.drWB_CannibalizationSet.setupOnChangeEvents([], self.ICannibalizationSet_onRecordChange.bind(self), self)
          _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (cspg) => {
            cspg.setupOnChangeEvents([],self.ICannibalizationSetProductGroup_onRecordChange.bind(self), self)
          })

          return self._AttributesOnLoadComplete()
        })
        .then((ignore:any) => {

          self.ICannibalizationSetActualsCalculator_onLoadComplete()

          self._bIsLoaded = true
          self._OnLoadComplete = undefined
          self.LoadProgressProvider.finish()
          resolve(self)
        })
        .catch(function (err: any) {
          self._OnLoadComplete = undefined
          self.LoadProgressProvider.exception(err)
          error(err)
          return;
        });

    });

    return this._OnLoadComplete;
  }

  get OnLoadComplete(): Promise<IBusinessObject> {
    return this._OnLoadComplete;
  }

  get bIsLoaded(): boolean {
    return this._bIsLoaded;
  }


  Validate(options?: any): Promise<IBusinessObject> {

    const self = this;
    this.ValidateMessageProvider.clearMessages();
    this.ValidateProgressProvider.start("Validating " + self.WB_CannibalizationSet.cif.CANN_NAME + "(" + self.WB_CannibalizationSet.cif.WB_CANN_ID + ")");
    return new Promise<IBusinessObject>((resolve, reject) => {
      // Does no validations yet
      self.ValidateOptions = options || {};

      if (self.dbContext == undefined) {
        var sError = "Unable to determine dbContext for to Validate Cannibalization Set.";
        self.ValidateProgressProvider.exception(sError);
        reject(sError);
      }


      self._bIsValidated = true;
      self.ValidateProgressProvider.finish();
      resolve(self);
    });
  }

  get bIsValidated(): boolean {
    return this._bIsValidated;
  }


  Save(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(false, options)
  }

  SaveBatch(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(true, options)
  }

  SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

    var self = this;
    var wbCannibalizationSet = <IwbCannibalizationSet>self.drWB_CannibalizationSet;
    this.SaveProgressProvider.start("Saving " + wbCannibalizationSet.CANN_NAME + "(" + wbCannibalizationSet.WB_CANN_ID + ")");

    return new Promise<IBusinessObject>((resolve, reject) => {
      // Doesn't need to do anything yet
      // All the records are in the store, since they were added through find or createNewRecord.
      // -- We could search the tree if the there is any record where store isn't set.

      if (self.dbContext == undefined) {
        self._bIsSaved = false;
        var sError = "Unable to determine dbContext to Save Cannibalization Set.";
        self.SaveProgressProvider.exception(sError);
        reject(sError);
        return
      }

      self.SaveOptions = options || {};

      var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
      if (bBatch) {
        saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
      } else {
        saveFunction = self.dbContext.Save.bind(self.dbContext)
      }

      // Add code to do individual BO save for dbContextRows....
      saveFunction(esWB_Cannibalization_Set, self.drWB_CannibalizationSet, {})
        .then((ignore) => {
          let tasks: Promise<any>[] = []

          tasks.push(saveFunction(esWB_Cannibalization_Set_Customer, self.drWB_CannibalizationSet.WB_CannibalizationSetCustomerRows))
          tasks.push(saveFunction(esWB_Cannibalization_Set_Product_Group, self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows))
          _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (cspg) => {
            tasks.push(saveFunction(esWB_Cannibalization_Set_Product, cspg.WB_CannibalizationSetProductRows))
          })
          return Promise.all(tasks)
        })
        .then((ignored) => {
          if (bBatch) {
            self.dbContext.addBatchCompleteListener(() => {
              self._bIsSaved = true;
            })
          } else {
            self._bIsSaved = true;
          }
          self.SaveProgressProvider.finish();
          resolve(self);
        })
        .catch((err) => {
          self.SaveProgressProvider.exception(err);
          resolve(self)
        })


    });
  }


  get bIsSaved(): boolean {
    return this._bIsSaved;
  }

//Delete
  Delete(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(true, options)
  }

  DeleteOnSave(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(false, options)
  }

  private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
    const self = this;
    const wCannibalizationSet = <IwbCannibalizationSet>self.drWB_CannibalizationSet;
    this.DeleteMessageProvider.clearMessages();
    this.DeleteProgressProvider.start("Deleting " + wCannibalizationSet.CANN_NAME + "(" + wCannibalizationSet.WB_CANN_ID + ")");
    return new Promise<IBusinessObject>((resolve, error) => {

      // 1. Validate if we can delete the Cannibalization Set

      // 2. If Valid, mark all the records for deletion.
      self.drWB_CannibalizationSet.markDeleted()
      _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetCustomerRows, (csc) => {
        csc.markDeleted()
      })

      _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (cspg) => {
        cspg.markDeleted()

        _.forEach(cspg.WB_CannibalizationSetProductRows, (csprd) => {
          csprd.markDeleted()
        })

      })


      if (bSaveNow) {
        self.SaveUsing(false)
          .then((ignore) => {
            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
            resolve(self);

          })
          .catch((err) => {
            this.DeleteProgressProvider.exception(err)
            resolve(self)
          })
      } else {
        self._bIsDeleted = true;
        self.DeleteProgressProvider.finish();
        resolve(self);
      }
    });
  }


  get bIsDeleted(): boolean {
    return this._bIsDeleted;
  }


//</editor-fold>

  //<editor-fold desc="Cannibalization Set Context Properties" >

  // These are loaded after the BO is loaded..

  private _ExecutionBoundsAll: ManualExecutionBounds
  private _ExecutionBoundsAggressor: ManualExecutionBounds
  private _ExecutionBoundsVictim: ManualExecutionBounds

  private _PlanningCustomer_WB_CustomerRows: WB_CustomerRow[] = []
  private _AffinityGroup_WB_ProductGroupRows: WB_ProductGroupRow[] = []

  private ICannibalizationSetContext_init() {
    let cgPP = new CannibalizationGroupManualExecutionBoundsProductsProvider()
    this._ExecutionBoundsAll = new ManualExecutionBounds()
    this._ExecutionBoundsAggressor = new ManualExecutionBounds()
    this._ExecutionBoundsVictim = new ManualExecutionBounds()

    this._ExecutionBoundsAll.ManualExecutionBoundsProductsProvider = cgPP
    this._ExecutionBoundsAggressor.ManualExecutionBoundsProductsProvider = cgPP
    this._ExecutionBoundsVictim.ManualExecutionBoundsProductsProvider = cgPP

    this._PlanningCustomer_WB_CustomerRows = []
    this._AffinityGroup_WB_ProductGroupRows = []

  }



  get ExecutionBoundsAll(): IHaveExecutionBounds {
    return this._ExecutionBoundsAll
  }

  get ExecutionBoundsAggressor(): ManualExecutionBounds {
    return this._ExecutionBoundsAggressor
  }

  get ExecutionBoundsVictim(): ManualExecutionBounds {
    return this._ExecutionBoundsVictim
  }


  get AffinityGroup_WB_ProductGroupRows(): WB_ProductGroupRow[] {
    return this._AffinityGroup_WB_ProductGroupRows;
  }

  get PlanningCustomer_WB_CustomerRows(): WB_CustomerRow[] {
    return this._PlanningCustomer_WB_CustomerRows
  }

  private _AttributesOnLoadComplete(): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      self._ExecutionBoundsAll.dbContext = self.dbContext
      self._ExecutionBoundsAggressor.dbContext = self.dbContext
      self._ExecutionBoundsAggressor.Execution_Bounds_Identity = self.Identity
      self._ExecutionBoundsVictim.dbContext = self.dbContext
      self._ExecutionBoundsVictim.Execution_Bounds_Identity = self.Identity

      self._ExecutionBoundsAll.pauseChangeNotifications()

      self._PlanningCustomer_WB_CustomerRows = _.map(self.drWB_CannibalizationSet.WB_CannibalizationSetCustomerRows, (aRow) => { return aRow.WB_CustomerRow})
      self._ExecutionBoundsAll.Execution_PlanningCustomers = self._PlanningCustomer_WB_CustomerRows
      self._ExecutionBoundsAll.Execution_InStoreStartDt = self.WB_CannibalizationSet.EffectiveStartDt
      self._ExecutionBoundsAll.Execution_InStoreEndDt = self.WB_CannibalizationSet.EffectiveEndDt

      self._ExecutionBoundsAggressor.Execution_InStoreStartDt = self.WB_CannibalizationSet.EffectiveStartDt
      self._ExecutionBoundsAggressor.Execution_InStoreEndDt = self.WB_CannibalizationSet.EffectiveEndDt
      self._ExecutionBoundsVictim.Execution_InStoreStartDt = self.WB_CannibalizationSet.EffectiveStartDt
      self._ExecutionBoundsVictim.Execution_InStoreEndDt = self.WB_CannibalizationSet.EffectiveEndDt

      if(self._PlanningCustomer_WB_CustomerRows.length == 1){
        self._ExecutionBoundsAggressor.Execution_PlanningCustomers = self._PlanningCustomer_WB_CustomerRows
        self._ExecutionBoundsVictim.Execution_PlanningCustomers = self._PlanningCustomer_WB_CustomerRows
      }

      if(_.isEmpty(self.WB_CannibalizationSet.WB_AffinitySet_ProductGroupRow)){
        self._ExecutionBoundsAll.resumeChangeNotifications()
        resolve()
        return
      }

      CannibalizationDataUtils.getAffinitySetProductGroups(self.dbContext, [self.WB_CannibalizationSet.WB_AffinitySet_ProductGroupRow])
        .then((aWBPrdGrpRows: WB_ProductGroupRow[]) => {
          self._AffinityGroup_WB_ProductGroupRows = aWBPrdGrpRows
          self._ExecutionBoundsAll.Execution_ProductGroups = self._AffinityGroup_WB_ProductGroupRows
          self._ExecutionBoundsAll.resumeChangeNotifications()
          resolve()
        })
        .catch((err) => {
          self._ExecutionBoundsAll.resumeChangeNotifications()
          error(err)
        })

    })
  }

  //</editor-fold>

  //<editor-fold desc = "ICannibalizationSet">

  private _CannibalizationSetPropertyChanged: BehaviorSubject<ICannibalizationSetChangedEvent>;

  private ICannibalizationSet_init(){
    this._CannibalizationSetPropertyChanged = new BehaviorSubject<ICannibalizationSetChangedEvent>(undefined)
  }

  private ICannibalizationSet_onRecordChange(record: WB_CannibalizationSetRow, propertyName: string, propertyValue: any, options: CannibalizationSetBO) {
    this.CannibalizationSetPropertyChanged.next({
      CannibalizationSetBO: options,
      Row: record,
      PropertyChanged: propertyName,
      PropertyValue: propertyValue
    })
  }


  get CannibalizationSetPropertyChanged(): BehaviorSubject<ICannibalizationSetChangedEvent>{
    return this._CannibalizationSetPropertyChanged
  }



//</editor-fold>

  //<editor-fold desc = "ICannibalizationSetProductGroup">

  private _CannibalizationProductGroupCollectionChanged: BehaviorSubject<CannibalizationSetBO>;
  private _CannibalizationProductGroupPropertyChanged: BehaviorSubject<ICannibalizationSetProductGroupChangedEvent>;

  private ICannibalizationSetProductGroup_init(){
    this._CannibalizationProductGroupCollectionChanged = new BehaviorSubject<CannibalizationSetBO>(undefined)
    this._CannibalizationProductGroupPropertyChanged = new BehaviorSubject<ICannibalizationSetProductGroupChangedEvent>(undefined)
  }

  private ICannibalizationSetProductGroup_onRecordChange(record: WB_CannibalizationSetProductGroupRow, propertyName: string, propertyValue: any, options: CannibalizationSetBO) {
    this._CannibalizationProductGroupPropertyChanged.next({
      CannibalizationSetBO: options,
      Row: record,
      PropertyChanged: propertyName,
      PropertyValue: propertyValue
    })
  }

  get CannibalizationProductGroupCollectionChanged(): BehaviorSubject<CannibalizationSetBO>{
    return this._CannibalizationProductGroupCollectionChanged
  }

  get CannibalizationProductGroupPropertyChanged(): BehaviorSubject<ICannibalizationSetProductGroupChangedEvent>{
    return this._CannibalizationProductGroupPropertyChanged
  }

  addCannibalizationProductGroup(options: ICannibalizationSetProductGroupAddOptions): Promise<WB_CannibalizationSetProductGroupRow> {
    const self = this

    return new Promise<WB_CannibalizationSetProductGroupRow>((resolve, error) => {
      let returnRow: WB_CannibalizationSetProductGroupRow = undefined

      self.dbContext.createRecordWithKey(esWB_Cannibalization_Set_Product_Group)
        .then((newRec:WB_CannibalizationSetProductGroupRow) => {
          returnRow = newRec
          newRec.setDefaults()
          newRec.cif.WB_CANN_ID = self.drWB_CannibalizationSet.cif.WB_CANN_ID

          // Set defaults using options

          // Add to Container
          self.dbContext.add(esWB_Cannibalization_Set_Product_Group, newRec)

          newRec.setupOnChangeEvents([],self.ICannibalizationSetProductGroup_onRecordChange.bind(self), self)

          self.CannibalizationProductGroupCollectionChanged.next(self)

          resolve(returnRow)

        })
        .catch((err) => {
          error(err)
        })

    })

  }

  removeCannibalizationProductGroup(aWB_CannPG_ID: number): Promise<void> {
    const self = this

    _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetProductGroupRows, (cpg) => {
      if (cpg.isActive) {
        if (cpg.cif.WB_CANNPG_ID == aWB_CannPG_ID) {
          cpg.markDeleted()

          _.forEach(cpg.WB_CannibalizationSetProductRows, (cprd) => {
            cprd.markDeleted()
          })
        }
      }
    })

    self.CannibalizationProductGroupCollectionChanged.next(self)

    return ASync.resolve()
  }



//</editor-fold>

  //<editor-fold desc = "IHaveCannibalizationSetActualsCalculator">

  private _ActualsCalculator: ICannibalizationSetActualsCalculator

  private ICannibalizationSetActualsCalculator_init(){
    this._ActualsCalculator = new CannibalizationSetActualsCalculator()
  }

  private ICannibalizationSetActualsCalculator_onLoadComplete() {
    this._ActualsCalculator.Register(this)
  }

  get ActualsCalculator(): ICannibalizationSetActualsCalculator {
    return this._ActualsCalculator
  }

  //</editor-fold>

  //<editor-fold desc = "Customer Operations">

  addCustomer(aWBCustId: number): Promise<void> {
    const self = this

    let found = false
    _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetCustomerRows, (acr) => {
      if(acr.isActive){
        if(acr.cif.WB_CUST_ID == aWBCustId){
          found = true
        }
      }
    })

    if(found){
      return ASync.resolve()
    }

    return new Promise<void>((resolve, error) => {

        let aCust: WB_CustomerRow
        self.dbContext.find(esWB_Customer, aWBCustId)
          .then((custRow: WB_CustomerRow) => {
            if(_.isEmpty(custRow)){
              error("Unable to find Customer")
              return
            }
            aCust = custRow
            return self.dbContext.createRecordWithKey(esWB_Cannibalization_Set_Customer)
          })
          .then((newRec: WB_CannibalizationSetCustomerRow)=> {
            newRec.setDefaults()
            newRec.cif.WB_CANN_ID = self.drWB_CannibalizationSet.cif.WB_CANN_ID
            newRec.cif.WB_CUST_ID = aWBCustId
            newRec.WB_CustomerRow = aCust
            newRec.cif.CUST_ROLE = "All"
            self.dbContext.add(esWB_Cannibalization_Set_Customer, newRec)
            resolve()
          })
          .catch((err) => {
            error(err)
          })
    })

  }

  removeCustomer(aWBCustId: number): Promise<void> {
    const self = this

    let found = false
    _.forEach(self.drWB_CannibalizationSet.WB_CannibalizationSetCustomerRows, (acr) => {
      if (acr.isActive) {
        if (acr.cif.WB_CUST_ID == aWBCustId) {
          acr.markDeleted()
        }
      }
    })

    return ASync.resolve()

  }

    //</editor-fold desc>


  //<editor-fold desc = "Record Resolver">

  static createRecordResolver(boLoadOptions: any): ESRecordResolver {

    let opts = boLoadOptions || {}
    let dbContext: PAdbContext

    if ('dbContext' in opts) {
      dbContext = opts.dbContext;
    } else {
      dbContext = new PAdbContext({});
    }
    const wrksp_options: CreateOptions = {
      standardConditions: {
      },
      dctIncludeBelongsToNamedRelations: {
      }
    }

    const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

    return aRecResolver;

  }

  static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

    return new Promise<void>((resolve, error) => {
      recordResolver.findAllWithRelationships(esWB_Cannibalization_Set,ids).then((result) => {
        resolve()
      }).catch((err) => {
        error(err)
      })
    })
  }

  static concurrentLoadCountHint(): number {
    return 10;
  }

  //</editor-fold desc>

};
PAEnvironment.registerBusinessObjectClass (CannibalizationSetBO, "CannibalizationSetBO", "Cannibalization Set")